import { createBrowserRouter, createRoutesFromElements } from "react-router-dom";
import '../index.css'
import Layout from "./Layout";

const router = createBrowserRouter(createRoutesFromElements(
    Layout
));

export default router
